import React from 'react';
import { clsx } from 'clsx';

import { PRICE_DEAL_TYPE_TABS } from '../../constants';
import * as styles from './styles.css';

import type { PriceDealType } from 'shared/types/pricesTable';

export interface IPriceDealTypeTabsProps {
  value: PriceDealType;
  onChange: (value: PriceDealType) => void;
}

export const PriceDealTypeTabs: React.FC<IPriceDealTypeTabsProps> = ({ value, onChange }) => (
  <div className={styles['deal-type-tabs']} role="tablist" aria-label="Тип сделки">
    {PRICE_DEAL_TYPE_TABS.map(tab => (
      <button
        key={tab.value}
        type="button"
        role="tab"
        aria-selected={value === tab.value}
        className={clsx(styles['deal-type-tabs__tab'], value === tab.value && styles['deal-type-tabs__tab_active'])}
        onClick={() => onChange(tab.value)}
      >
        {tab.label}
      </button>
    ))}
  </div>
);
